'use strict';

function permute(array, index, deep) {
  for (var i = 0, n = index.length, copy = deep ? JSON.parse(JSON.stringify(array)) : new Array(n); i < n; ++i) {
    copy[i] = array[index[i]];
  }
  return copy;
}

module.exports = permute;



//////////////////
// WEBPACK FOOTER
// ./~/crossfilter2/src/permute.js
// module id = 888
// module chunks = 0